import React, { useEffect, useState, FormEvent } from 'react';
import { ComboBox, IComboBoxOption, IComboBox } from '@fluentui/react';
import { useConfigValuesState } from '../../../../../hooks/useConfigValue';

const errorSpanStyle = {
    fontFamily: '"Segoe UI", "Segoe UI Web (West European)", "Segoe UI", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", sans-serif',
    fontSize: '12px',
    // fontWeight: '400px',
    color: 'rgb(164,38,44)',
} as React.CSSProperties;

function TimeLowerLimitConfig() {
    const [selectedComboKey, setSelectedComboKey] = useState<string>(null);
    const [comboboxError, setComboboxError] = useState<string>('');

    const [DEFAULT_OPTIONS, setDEFAULT_OPTIONS] = useState<IComboBoxOption[]>([
        { key: '0', text: 'Default rounding' },
        { key: '1', text: 'No decimals' },
        { key: '0.1', text: '0.1' },
        { key: '0.25', text: '0.25' },
        { key: '0.5', text: '0.5' },
    ]);

    const {
        initialData: {
            configuration: { timeEntryRoundingInterval },
        },
        setConfigValue,
    } = useConfigValuesState();

    useEffect(() => {
        const timeEntryRoundingIntervalString = String(timeEntryRoundingInterval);
        if (DEFAULT_OPTIONS.find(o => o.key === timeEntryRoundingIntervalString) === undefined) {
            setDEFAULT_OPTIONS(prevState => {
                return prevState.concat([{ key: timeEntryRoundingIntervalString, text: timeEntryRoundingIntervalString }]);
            });
        }
        setSelectedComboKey(timeEntryRoundingIntervalString);
    }, [DEFAULT_OPTIONS, timeEntryRoundingInterval]);

    const onComboChange = (event: FormEvent<IComboBox>, option: IComboBoxOption, index: number, value: string): void => {
        let finalComboOption = undefined;

        if (option !== undefined) {
            finalComboOption = option;
        } else {
            try {
                const validatedValue = parseFloat(value);
                if (validatedValue < 0 || Number.isNaN(validatedValue)) {
                    setComboboxError('Woops, input needs to be a positive float value.');
                    return;
                }
            } catch (error) {
                setComboboxError('Woops, input needs to be a positive float value.');
                return;
            }
            if (DEFAULT_OPTIONS.find(o => o.key === value) === undefined) {
                setDEFAULT_OPTIONS(prevState => {
                    return prevState.concat([{ key: value, text: value }]);
                });
                finalComboOption = { key: value, text: value };
            }
        }

        if (finalComboOption !== undefined) {
            setSelectedComboKey(finalComboOption.key);
            setConfigValue(config => {
                return {
                    ...config,
                    timeEntryRoundingInterval: Number(finalComboOption.key),
                };
            });
        }

        setComboboxError('');
    };

    return (
        <div>
            <ComboBox
                label="Time Entry Interval (rounds to nearest interval)"
                multiSelect={false}
                allowFreeform={true}
                autoComplete={'off'}
                options={DEFAULT_OPTIONS}
                selectedKey={selectedComboKey}
                onChange={onComboChange}
            />
            <span style={errorSpanStyle} hidden={!comboboxError}>
                {comboboxError}
            </span>
        </div>
    );
}

export default TimeLowerLimitConfig;
